export { default as ListView } from 'groups/components/GroupsListView';
export { default as FormView } from 'groups/components/GroupFormView';



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/index.js